import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.expert.program.item');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-expert-program-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.expert.program.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageExpertProgramItemComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public loading: boolean = true;
    public programId: string = '';
    public applicationId: string = '';
    public program: any = {};
    public criteria: any[] = [];
    public applications: any[] = [];
    public selected: any = null;
    public stage: string = 'doc';
    public form: any = { scores: {}, comment: '' };
    public saving: boolean = false;
    public detailLoading: boolean = false;
    public evalFilter: string = 'ongoing';
    public evalFilters: any[] = [
        { key: 'ongoing', label: '진행중 평가/멘토링' },
        { key: 'completed', label: '종료된 평가/멘토링' },
    ];
    public evaluatorDocs: any = { provided: [], requests: [] };
    public selectedEvaluatorDoc: any = null;
    public selectedEvaluatorDocMode: string = 'provide';
    public showEvaluatorDocPopup: boolean = false;
    public evaluatorDocForm: any = { form_data: {} };
    private routerSub: any = null;

    public async ngOnInit() {
        await this.service.init();
        this.programId = WizRoute.segment.program_id;
        this.applicationId = WizRoute.segment.application_id || '';
        await this.loadProgram();
        await this.loadEvaluatorDocuments();
        await this.loadApplications();
        if (this.applicationId) await this.openApplication(this.applicationId);
        this.loading = false;
        await this.service.render();

        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const newApp = WizRoute.segment.application_id || '';
                if (newApp !== this.applicationId) {
                    this.applicationId = newApp;
                    if (newApp) await this.openApplication(newApp);
                    else this.selected = null;
                    await this.service.render();
                }
            }
        });
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private async loadProgram() {
        try {
            const res = await wiz.call("get_program", { program_id: this.programId });
            if (res.code === 200) {
                this.program = res.data.program || {};
                this.criteria = res.data.criteria || [];
            }
        } catch (e) { }
    }

    public programDisplayTitle(): string {
        return this.program?.display_title || this.program?.title || '-';
    }

    private async loadApplications() {
        try {
            const res = await wiz.call("list_applications", { program_id: this.programId });
            if (res.code === 200) {
                this.applications = res.data.rows || [];
            }
        } catch (e) { }
    }

    private async loadEvaluatorDocuments() {
        try {
            const res = await wiz.call("list_evaluator_documents", { program_id: this.programId });
            if (res.code === 200) {
                this.evaluatorDocs = res.data?.context || { provided: [], requests: [] };
            }
        } catch (e) {
            this.evaluatorDocs = { provided: [], requests: [] };
        }
    }

    public hasEvaluatorDocs(): boolean {
        return ((this.evaluatorDocs?.provided || []).length + (this.evaluatorDocs?.requests || []).length) > 0;
    }

    public evaluatorRequestStatus(req: any): any {
        if (req?.submission?.status === 'submitted') return { label: '제출 완료', cls: 'bg-blue-50 text-blue-700' };
        if (req?.submission?.status === 'approved') return { label: '확인 완료', cls: 'bg-emerald-50 text-emerald-700' };
        if (req?.submission?.status === 'rejected') return { label: '반려', cls: 'bg-red-50 text-red-700' };
        return { label: '미제출', cls: 'bg-zinc-100 text-zinc-600' };
    }

    public openEvaluatorDoc(doc: any, mode: string) {
        this.selectedEvaluatorDoc = doc;
        this.selectedEvaluatorDocMode = mode === 'request' ? 'request' : 'provide';
        this.evaluatorDocForm = {
            form_data: {
                ...((doc?.submission && doc.submission.form_data) || {}),
            },
        };
        this.showEvaluatorDocPopup = true;
        this.service.render();
    }

    public closeEvaluatorDoc() {
        this.showEvaluatorDocPopup = false;
        this.selectedEvaluatorDoc = null;
        this.evaluatorDocForm = { form_data: {} };
        this.service.render();
    }

    public evaluatorFieldInputType(f: any): string {
        if (f?.type === 'date') return 'date';
        if (f?.type === 'number') return 'number';
        return 'text';
    }

    public evaluatorDocFileValue(f: any): any {
        if (!f?.key) return null;
        return (this.evaluatorDocForm.form_data || {})[f.key] || null;
    }

    public evaluatorDocFileLabel(f: any): string {
        const value = this.evaluatorDocFileValue(f);
        if (!value) return '';
        if (typeof value === 'object') return value.name || value.file_name || value.url || '업로드 파일';
        return String(value);
    }

    public evaluatorDocFileUrl(f: any): string {
        const value = this.evaluatorDocFileValue(f);
        if (!value) return '';
        if (typeof value === 'object') return value.url || value.file_url || '';
        const text = String(value);
        if (text.indexOf('/file/download/') === 0 || text.indexOf('http://') === 0 || text.indexOf('https://') === 0) return text;
        return '';
    }

    public async uploadEvaluatorDocField(f: any) {
        if (!f?.key) return;
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        try {
            const fd = new FormData();
            fd.append('upload', files[0]);
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            if (!this.evaluatorDocForm.form_data) this.evaluatorDocForm.form_data = {};
            this.evaluatorDocForm.form_data[f.key] = { name: files[0].name, url };
        } catch (e) {
            this.service.alert.show({ title: '오류', message: '파일 업로드에 실패했습니다.' });
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public removeEvaluatorDocFieldFile(f: any) {
        if (!f?.key || !this.evaluatorDocForm.form_data) return;
        delete this.evaluatorDocForm.form_data[f.key];
        this.service.render();
    }

    private evaluatorFieldMissing(field: any, value: any): boolean {
        if (field?.type === 'checkbox') return value !== true;
        if (Array.isArray(value)) return value.length === 0;
        if (value === undefined || value === null) return true;
        return String(value).trim() === '';
    }

    public async submitEvaluatorDoc() {
        const req = this.selectedEvaluatorDoc;
        if (!req || this.selectedEvaluatorDocMode !== 'request') return;
        const missing = (req.fields || [])
            .filter((f: any) => f.required && this.evaluatorFieldMissing(f, this.evaluatorDocForm.form_data?.[f.key]))
            .map((f: any) => f.label || f.key);
        if (missing.length > 0) {
            this.service.alert.show({ title: '오류', message: `필수 항목을 입력하세요: ${missing.join(', ')}` });
            return;
        }
        const payload = {
            program_id: this.programId,
            request_id: req.id,
            form_data: this.evaluatorDocForm.form_data || {},
        };
        const res = await wiz.call('submit_evaluator_document', { data: JSON.stringify(payload) });
        if (res.code !== 200) {
            this.service.alert.show({ title: '오류', message: res.data?.message || '제출 실패' });
            return;
        }
        this.showEvaluatorDocPopup = false;
        await this.loadEvaluatorDocuments();
        await this.service.render();
        this.service.alert.show({ title: '완료', message: '요청 자료가 제출되었습니다.' });
    }

    public async openApplication(appId: string) {
        const a = this.applications.find(x => x.id === appId);
        this.selected = a ? { ...a } : null;
        this.applicationId = appId;
        if (this.selected) {
            this.evalFilter = this.applicationEvalState(this.selected);
            this.loadFromMyEval();
        }
        this.detailLoading = true;
        await this.service.render();
        try {
            const res = await wiz.call("get_application_detail", { application_id: appId });
            if (res.code === 200) {
                const detail = res.data?.detail || {};
                const app = detail.application || {};
                const myMap = this.normalizeEvaluationMap(detail.my_evaluations);
                this.selected = {
                    ...(this.selected || {}),
                    ...app,
                    form_fields: detail.form_fields || [],
                    my_evaluations: {
                        ...((this.selected && this.selected.my_evaluations) || {}),
                        ...myMap,
                    },
                };
                this.evalFilter = this.applicationEvalState(this.selected);
                this.loadFromMyEval();
            } else {
                this.service.alert.show({ title: '상세 조회 실패', message: res.data?.message || '신청 서류를 불러올 수 없습니다.' });
            }
        } catch (e: any) {
            this.service.alert.show({ title: '상세 조회 실패', message: e?.message || String(e) });
        }
        this.detailLoading = false;
        await this.service.render();
    }

    public async selectAndNav(a: any) {
        this.service.href(`/expert/program/${this.programId}/${a.id}`);
    }

    public backToList() {
        this.selected = null;
        this.applicationId = '';
        this.service.href(`/expert/program/${this.programId}`);
    }

    private loadFromMyEval() {
        this.stage = this.firstAssignedStage();
        this.form = { scores: {}, comment: '' };
        const my = this.currentEval();
        if (my) {
            this.form = { scores: { ...(my.scores || {}) }, comment: my.comment || '' };
        }
    }

    public onStageChange() {
        const my = this.currentEval();
        if (my) {
            this.form = { scores: { ...(my.scores || {}) }, comment: my.comment || '' };
        } else {
            this.form = { scores: {}, comment: '' };
        }
    }

    public criterionScore(key: string): number {
        const v = this.form?.scores?.[key];
        return (v === undefined || v === null) ? 0 : Number(v);
    }

    public setCriterionScore(key: string, value: any, max: number) {
        let n = Number(value);
        if (isNaN(n)) n = 0;
        if (n < 0) n = 0;
        if (n > max) n = max;
        if (!this.form.scores) this.form.scores = {};
        this.form.scores[key] = n;
    }

    public rawTotal(): number {
        let t = 0;
        for (const c of this.criteria) t += this.criterionScore(c.key);
        return Math.round(t * 100) / 100;
    }

    public maxTotal(): number {
        let t = 0;
        for (const c of this.criteria) t += Number(c.max_score || 0);
        return t;
    }

    public normalizedTotal(): number {
        const m = this.maxTotal();
        if (!m) return 0;
        return Math.round((this.rawTotal() / m) * 100 * 100) / 100;
    }

    public async submit() {
        if (!this.selected) return;
        if (!this.isCurrentStageAssigned()) {
            this.service.alert.show({ title: '평가 요청 없음', message: '배정되지 않은 평가 단계입니다.' });
            return;
        }
        if (!this.canEditCurrentEval()) {
            this.service.alert.show({ title: '수정 불가', message: '이미 제출된 평가는 관리자 반려 후 수정할 수 있습니다.' });
            return;
        }
        if (this.criteria.length === 0) {
            this.service.alert.show({ title: '평가 항목 없음', message: '아직 평가 항목이 설정되지 않았습니다. 관리자에게 문의해주세요.' });
            return;
        }
        this.saving = true;
        await this.service.render();
        const payload: any = {
            application_id: this.selected.id,
            program_id: this.programId,
            stage: this.stage,
            scores: this.form.scores || {},
            comment: this.form.comment || '',
        };
        const my = this.currentEval();
        if (my && my.id) payload.id = my.id;
        try {
            const res = await wiz.call("upsert_evaluation", { data: JSON.stringify(payload) });
            if (res.code === 200) {
                this.service.alert.show({ title: '저장 완료', message: '평가가 저장되었습니다.' });
                const currentId = this.selected.id;
                await this.loadApplications();
                await this.openApplication(currentId);
                const refreshed = this.applications.find((x: any) => x.id === currentId);
                if (refreshed) this.evalFilter = this.applicationEvalState(refreshed);
            } else {
                this.service.alert.show({ title: '저장 실패', message: res.data?.message || '평가 저장에 실패했습니다.' });
            }
        } catch (e: any) {
            this.service.alert.show({ title: '오류', message: e?.message || String(e) });
        }
        this.saving = false;
        await this.service.render();
    }

    public stageLabel(s: string): string {
        return s === 'doc' ? '서류' : (s === 'pt' ? '발표' : '현장');
    }

    private firstAssignedStage(): string {
        const stages = ['doc', 'pt', 'field'];
        for (const s of stages) {
            if (this.selected?.my_evaluations?.[s]) return s;
        }
        return 'doc';
    }

    private normalizeEvaluationMap(source: any): any {
        const map: any = {};
        if (Array.isArray(source)) {
            for (const ev of source) {
                if (!ev) continue;
                map[ev.stage || 'doc'] = {
                    id: ev.id,
                    score: ev.score || 0,
                    scores: ev.scores || {},
                    comment: ev.comment || '',
                    status: ev.status || 'pending',
                    submitted_at: ev.submitted_at,
                    extra: ev.extra || {},
                    assignment_request: ev.assignment_request || ev.extra?.assignment_request || {},
                };
            }
            return map;
        }
        if (source && typeof source === 'object') return source;
        return map;
    }

    public assignedStages(target: any = this.selected): string[] {
        const map = target?.my_evaluations || {};
        return ['doc', 'pt', 'field'].filter((s: string) => !!map[s]);
    }

    public stageOptions(): any[] {
        const stages = this.assignedStages();
        const base = stages.length > 0 ? stages : ['doc'];
        return base.map((s: string) => ({ key: s, label: this.stageLabel(s) }));
    }

    public currentEval(): any {
        return this.selected?.my_evaluations?.[this.stage] || null;
    }

    public isCurrentStageAssigned(): boolean {
        return !!this.currentEval();
    }

    public canEditCurrentEval(): boolean {
        const ev = this.currentEval();
        if (!ev) return false;
        return ev.status !== 'submitted';
    }

    public currentAssignmentRequest(): any {
        const ev = this.currentEval();
        const req = ev?.assignment_request || ev?.extra?.assignment_request || {};
        return {
            documents: req?.documents || '',
            note: req?.note || '',
        };
    }

    public hasCurrentAssignmentRequest(): boolean {
        const req = this.currentAssignmentRequest();
        return !!((req.documents || '').trim() || (req.note || '').trim());
    }

    public requestDocumentLines(value: any): string[] {
        return String(value || '').split('\n').map((v: string) => v.trim()).filter((v: string) => !!v);
    }

    public evalStatusInfo(status: string): any {
        const map: any = {
            pending: { label: '미제출', cls: 'bg-zinc-100 text-zinc-600' },
            submitted: { label: '제출 완료', cls: 'bg-emerald-50 text-emerald-700' },
            rejected: { label: '반려', cls: 'bg-red-50 text-red-700' },
        };
        return map[status || 'pending'] || { label: status || '-', cls: 'bg-zinc-100 text-zinc-600' };
    }

    public applicationStatusInfo(status: string): any {
        const map: any = {
            submitted: { label: '접수', cls: 'bg-blue-50 text-blue-700' },
            screening: { label: '심사중', cls: 'bg-amber-50 text-amber-700' },
            doc_passed: { label: '서류통과', cls: 'bg-emerald-50 text-emerald-700' },
            doc_failed: { label: '서류탈락', cls: 'bg-red-50 text-red-700' },
            pt_passed: { label: '발표통과', cls: 'bg-emerald-100 text-emerald-800' },
            pt_failed: { label: '발표탈락', cls: 'bg-red-100 text-red-800' },
            selected: { label: '최종선정', cls: 'bg-emerald-600 text-white' },
            rejected: { label: '최종탈락', cls: 'bg-zinc-500 text-white' },
            withdrawn: { label: '철회', cls: 'bg-zinc-100 text-zinc-500' },
        };
        return map[status || ''] || { label: status || '-', cls: 'bg-zinc-100 text-zinc-600' };
    }

    public myStageStatusInfo(a: any, stage: string): any {
        const ev = a?.my_evaluations?.[stage];
        if (!ev) return { label: '미배정', cls: 'bg-zinc-50 text-zinc-400' };
        return this.evalStatusInfo(ev.status);
    }

    public hasMyEval(a: any, stage: string = 'doc'): boolean {
        return !!(a?.my_evaluations && a.my_evaluations[stage]?.status === 'submitted');
    }

    public myStageScore(a: any, stage: string): number {
        return a?.my_evaluations?.[stage]?.score || 0;
    }

    public hasAnySubmittedEval(a: any): boolean {
        return this.assignedStages(a).some((s: string) => this.hasMyEval(a, s));
    }

    public primaryActionLabel(a: any): string {
        return this.hasAnySubmittedEval(a) ? '보기' : '평가하기';
    }

    public applicationEvalState(a: any): string {
        if (a?.eval_state === 'completed') return 'completed';
        const stages = this.assignedStages(a);
        if (stages.length === 0) return 'ongoing';
        return stages.every((s: string) => a?.my_evaluations?.[s]?.status === 'submitted') ? 'completed' : 'ongoing';
    }

    public filteredApplications(): any[] {
        return (this.applications || []).filter((a: any) => this.applicationEvalState(a) === this.evalFilter);
    }

    public evalFilterCount(key: string): number {
        const state = key === 'completed' ? 'completed' : 'ongoing';
        let count = 0;
        for (const a of (this.applications || [])) {
            for (const s of this.assignedStages(a)) {
                const status = a?.my_evaluations?.[s]?.status || 'pending';
                const opState = status === 'submitted' ? 'completed' : 'ongoing';
                if (opState === state) count += 1;
            }
        }
        return count;
    }

    public filteredOperationCount(): number {
        return this.evalFilterCount(this.evalFilter);
    }

    public submittedStageCount(a: any): number {
        return this.assignedStages(a).filter((s: string) => this.hasMyEval(a, s)).length;
    }

    public detailMenuClass(key: string): string {
        const base = 'w-full flex items-center justify-between rounded-lg border px-3 py-2 text-[13px] transition ';
        if (this.evalFilter === key) return base + 'border-emerald-500 bg-emerald-50 text-emerald-800';
        return base + 'border-zinc-200 bg-white text-zinc-600 hover:bg-zinc-50';
    }

    public detailApplicationClass(a: any): string {
        const base = 'w-full rounded-lg border px-3 py-2 text-left text-[13px] transition ';
        if (this.selected?.id === a?.id) return base + 'border-emerald-500 bg-emerald-50 text-emerald-900';
        return base + 'border-zinc-200 bg-white text-zinc-700 hover:bg-zinc-50';
    }

    public evalStateBadgeClass(a: any): string {
        return this.applicationEvalState(a) === 'completed' ? 'bg-zinc-100 text-zinc-600' : 'bg-amber-50 text-amber-700';
    }

    public async setEvalFilter(key: string) {
        this.evalFilter = key === 'completed' ? 'completed' : 'ongoing';
        await this.service.render();
    }

    public applicationEmptyMessage(): string {
        return this.evalFilter === 'completed' ? '종료된 평가/멘토링 대상이 없습니다.' : '진행중인 평가/멘토링 대상이 없습니다.';
    }

    public safeObject(value: any): any {
        if (value && typeof value === 'object' && !Array.isArray(value)) return value;
        if (typeof value === 'string' && value.trim()) {
            try {
                const parsed = JSON.parse(value);
                return (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) ? parsed : {};
            } catch { return {}; }
        }
        return {};
    }

    public applicationAttachments(): any[] {
        const attachments = this.selected?.attachments;
        if (Array.isArray(attachments)) return attachments;
        if (typeof attachments === 'string' && attachments.trim()) {
            try {
                const parsed = JSON.parse(attachments);
                return Array.isArray(parsed) ? parsed : [];
            } catch { return []; }
        }
        return [];
    }

    public proposalFileUrl(): string {
        const url = this.selected?.proposal_file || '';
        return typeof url === 'string' ? url : '';
    }

    private attachmentBlob(a: any): string {
        return [
            a?.key, a?.field_id, a?.field_label, a?.label,
            a?.original_name, a?.name, a?.stored_name, a?.path,
        ].filter((x: any) => !!x).join(' ').toLowerCase();
    }

    public reviewAttachments(kind: 'plan' | 'ir' | 'all'): any[] {
        const all = this.applicationAttachments();
        if (kind === 'all') return all;
        const planTokens = ['plan', 'proposal', 'business', '사업계획', '사업 계획', '계획서', '서류'];
        const irTokens = ['ir', 'deck', 'pitch', '피칭', '발표', '투자유치'];
        const tokens = kind === 'plan' ? planTokens : irTokens;
        return all.filter((a: any) => {
            const blob = this.attachmentBlob(a);
            return tokens.some((t: string) => blob.indexOf(t) >= 0);
        });
    }

    public attachmentDownloadUrl(a: any): string {
        if (!a || !this.selected?.id) return '#';
        if (a.path) {
            const params = new URLSearchParams({ application_id: this.selected.id, path: a.path });
            return `/wiz/api/portal.lpsysadmin.support.application.item/download?${params.toString()}`;
        }
        if (a.stored_name) {
            const params = new URLSearchParams({
                application_id: this.selected.id,
                stored_name: a.stored_name,
                original_name: a.original_name || a.name || a.stored_name,
            });
            return `/wiz/api/portal.lpsysadmin.support.program.item/download_application_file?${params.toString()}`;
        }
        return a.url || '#';
    }

    public attachmentName(a: any): string {
        return a?.original_name || a?.name || a?.stored_name || a?.path || '파일';
    }

    public attachmentBadge(a: any): string {
        return a?.field_label || a?.field_id || a?.key || '';
    }

    public formatBytes(size: any): string {
        const n = Number(size || 0);
        if (!n) return '';
        if (n < 1024) return `${n}B`;
        if (n < 1024 * 1024) return `${Math.round(n / 1024)}KB`;
        return `${Math.round((n / 1024 / 1024) * 10) / 10}MB`;
    }

    public formData(): any {
        const extra = this.safeObject(this.selected?.extra);
        return this.safeObject(extra.form_data || this.selected?.form_data || {});
    }

    public formFields(): any[] {
        const fields = this.selected?.form_fields || [];
        return Array.isArray(fields) ? fields : [];
    }

    public formAnswerRows(): any[] {
        const data = this.formData();
        const fields = this.formFields();
        const used: any = {};
        const rows: any[] = [];
        for (const f of fields) {
            const key = f?.id || f?.key;
            if (!key || f?.type === 'file') continue;
            if (data[key] === undefined || data[key] === null || data[key] === '') continue;
            used[key] = true;
            rows.push({ key, label: f.label || key, value: data[key] });
        }
        for (const key of Object.keys(data || {})) {
            if (used[key]) continue;
            const value = data[key];
            if (value === undefined || value === null || value === '') continue;
            rows.push({ key, label: key, value });
        }
        return rows;
    }

    public displayValue(value: any): string {
        if (Array.isArray(value)) return value.join(', ');
        if (value && typeof value === 'object') return JSON.stringify(value);
        return String(value === undefined || value === null ? '' : value);
    }
}

export default PageExpertProgramItemComponent;